import React from 'react'
import { AddCircle } from 'iconsax-react'
import { useAppSelector } from '../../../../hooks/redux'
import { useTheme } from '@mui/material'

import ArticleItem from '../ArticleItem'
import ArticleView from '../ArticleView'
import Tooltip from '../../../../components/atoms/Tooltip'
import NewDocumentFolderModal from '../../../../components/molecules/ChatModals/NewDocumentFolderModal'

import useAccess, { PERMS } from '@SonarCX/hooks/useAccess'
import useStyles from './styles'

type ArticleHolderProps = {
  parent: string | null
  item: APIArticleItem
  depth: number
  isExpanded: boolean
  toggle: (id: string) => void
  zIndex: number
}

const ArticleHolder: React.FC<ArticleHolderProps> = ({
  parent,
  item,
  depth,
  isExpanded,
  toggle,
  zIndex
}) => {
  const theme = useTheme()
  const hasPermission = useAccess()

  const { articles } = useAppSelector(state => state.article)

  const [hovering, setHovering] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)

  const classes = useStyles()

  const hasPermissions = React.useMemo(
    () => hasPermission([PERMS.ArticlesFull, PERMS.ArticlesAdmin]),
    [hasPermission]
  )

  const startHovering = React.useCallback(() => {
    setHovering(true)
  }, [])

  const endHovering = React.useCallback(() => {
    setHovering(false)
  }, [])

  const openModal = React.useCallback(() => {
    setModalOpen(true)
  }, [])

  const closeModal = React.useCallback(() => {
    setModalOpen(false)
  }, [])

  return (
    <>
      <div
        onMouseEnter={startHovering}
        onMouseLeave={endHovering}
        className={classes.root}
      >
        <ArticleItem
          parent={parent}
          item={item}
          depth={depth}
          expanded={isExpanded}
          toggle={toggle}
          zIndex={zIndex}
        />

        {isExpanded && articles[item.id] && (
          <div className={classes.items}>
            <ArticleView
              items={articles[item.id].items}
              parent={item.id}
              depth={depth + 1}
              parentZ={zIndex - 1}
            />
          </div>
        )}

        {/* Hover to add folder on root */}
        {hasPermissions && depth === 0 && hovering && (
          <div className={classes.line} style={{ zIndex: zIndex + 100 }}>
            <Tooltip title='Create New Folder' arrow>
              <div onClick={openModal} className={classes.addFolderButton}>
                <AddCircle size={theme.size.sm} />
              </div>
            </Tooltip>
          </div>
        )}
      </div>

      {modalOpen && (
        <NewDocumentFolderModal
          parent={parent}
          onClose={closeModal}
          addBelow={item.id}
        />
      )}
    </>
  )
}

export default ArticleHolder
